import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { getAllocateBudgetList } from "../../../helper/Api";
import { useNavigate } from "react-router-dom";
import "./BudgetAllocationList.css";
import { Accordion } from "react-bootstrap";
import BudgetAllocationOverlay from "./Components/BudgetAllocationOverlay";

const BudgetAllocationListNew = (listType) => {
  const { authData, financialYears } = useSelector((state) => state.authData);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [overlay, setOverlay] = useState(true);
  const [overlayDropDown, setOverlayDropDown] = useState(false);
  const globalDateId = localStorage.getItem("globalDateId");
  const fy_list = financialYears.payload.fy_list;
  const [activeCard, setActiveCard] = useState([]);
  const [activeKeys, setActiveKeys] = useState([]); // Initially open accordions

  function getFinancialYearDates(year) {
    const startDate = `${year}-04-01`;
    const endDate = `${Number(year) + 1}-03-31`;
    return { start: startDate, end: endDate };
  }

  const toggleAccordion = (key) => {
    setActiveKeys(
      (prevKeys) =>
        prevKeys.includes(key)
          ? prevKeys.filter((k) => k !== key) // Remove key if it's already open
          : [...prevKeys, key] // Add key if it's closed
    );
  };

  function transformBudgetData(data) {
    const schemeMap = new Map();

    data.forEach((item) => {
      const schemeId = item.scheme_id;
      const schemeCode = item.code;

      if (!schemeMap.has(schemeId)) {
        schemeMap.set(schemeId, {
          scheme_id: schemeId,
          code: schemeCode,
          records: [],
          subheads: new Map(),
        });
      }

      const schemeEntry = schemeMap.get(schemeId);

      // Add record with departments count
      const record = {
        ...item,
        departments: item.budget_details?.length || 0,
      };
      schemeEntry.records.push(record);

      item.budget_details.forEach((detail) => {
        const subheadId = detail.subhead_id;

        if (!schemeEntry.subheads.has(subheadId)) {
          schemeEntry.subheads.set(subheadId, {
            subhead_id: subheadId,
            budget: 0,
            provisional_budget: 0,
            name: detail.name || "",
            code: detail.code || "",
            activitiesMap: new Map(),
          });
        }

        const subhead = schemeEntry.subheads.get(subheadId);
        subhead.budget += parseFloat(detail.budget || 0);
        subhead.provisional_budget += parseFloat(
          detail.provisional_budget || 0
        );

        // Process activities
        (detail.activities || []).forEach((activity) => {
          const actId = activity.subhead_activity_id;
          const actName = activity.activity;

          if (!subhead.activitiesMap.has(actId)) {
            subhead.activitiesMap.set(actId, {
              subhead_activity_id: actId,
              activity: actName,
              budget: 0,
              provisional_budget: 0,
              subactivitiesMap: new Map(),
            });
          }

          const act = subhead.activitiesMap.get(actId);
          act.budget += parseFloat(activity.budget || 0);
          act.provisional_budget += parseFloat(
            activity.provisional_budget || 0
          );

          // Process subactivities inside activity
          const subactId = activity.subhead_subactivity_id;
          const subactName = activity.subactivity;
          if (subactId) {
            if (!act.subactivitiesMap.has(subactId)) {
              act.subactivitiesMap.set(subactId, {
                subhead_subactivity_id: subactId,
                subactivity: subactName || "",
                budget: 0,
                provisional_budget: 0,
              });
            }

            const subact = act.subactivitiesMap.get(subactId);
            subact.budget += parseFloat(activity.budget || 0);
            subact.provisional_budget += parseFloat(
              activity.provisional_budget || 0
            );
          }
        });
      });
    });

    // Final conversion
    return Array.from(schemeMap.values()).map((entry) => {
      const subheadBudgets = Array.from(entry.subheads.values()).map((sub) => {
        const { activitiesMap, ...rest } = sub;

        const activities = Array.from(activitiesMap.values()).map((act) => {
          const { subactivitiesMap, ...cleanAct } = act;
          return {
            ...cleanAct,
            subactivities: Array.from(subactivitiesMap.values()),
          };
        });

        return {
          ...rest,
          activities,
        };
      });

      const total_budget = subheadBudgets.reduce((sum, s) => sum + s.budget, 0);
      const total_provisional_budget = subheadBudgets.reduce(
        (sum, s) => sum + s.provisional_budget,
        0
      );

      return {
        scheme_id: entry.scheme_id,
        code: entry.code,
        total_budget,
        total_provisional_budget,
        records: entry.records,
        subhead_budgets: subheadBudgets,
      };
    });
  }

  const mainCardSwitch = (val1, val2, val3, detailObj) => {
    setActiveCard((prev) => {
      let updated = [...prev];
      // Remove val2 and val3 if present
      updated = updated.filter((item) => item !== val2 && item !== val3);
      // Add val1 if not already present
      if (!updated.includes(val1)) {
        updated.unshift(val1); // Add at the beginning
      }
      return updated;
    });
  };

  const fetchBudgets = async (payload) => {
    try {
      const { data } = await getAllocateBudgetList(payload);
      setData(transformBudgetData(data.result));
    } catch (error) {
      setData([]);
      console.log(error);
    }
  };
  useEffect(() => {
    const financialYear = fy_list.find(e => e.id == globalDateId);
    const { start, end } = getFinancialYearDates(financialYear.start_year);
    fetchBudgets({
      approval: listType.approval,
      pending: listType.pending,
      tier: listType.tier,
      department_id: listType.departmentId || authData.user.department_id,
      from_date: listType.fromDate || start,
      to_date: listType.toDate || end,
      fy_id: listType.fyId || globalDateId,
      search_str: listType.searchStr,
      all: listType.all,
    });
  }, [
    listType.tier,
    listType.departmentId,
    listType.fromDate,
    listType.toDate,
    listType.searchStr,
    listType.all,
    listType.pending,
  ]);

  const [hoveredId, setHoveredId] = useState(null); // Track the hovered ID

  const handleMouseEnter = (id) => {
    setHoveredId(id); // Set the ID of the hovered div
  };

  const handleMouseLeave = () => {
    setHoveredId(null); // Reset when hover ends
  };
  const bodyRef = useRef(null);
  const [allocationDetails, setAllocationDetails] = useState(null);
  const viewAllocationDetails = (record) => {
    setAllocationDetails(record);
    setOverlay(false);
  };

  return (
    <div>
      <div className="row">
        <div className="px-3 col-12 col-lg-9 d-flex flex-column gap-3 mb-4">
          {data.map((budget, idx) => (
            <div className="rounded-3 bg-white " key={idx}>
              <div
                className="header bg-prime-20 fs-14px fst-italic p-2 "
                style={{ borderRadius: "8px 8px 0 0" }}
              >
                {budget.code} | {budget?.records[0].name}
              </div>

              <div className="p-1 m-0 overflow-md-scroll w-100 ">
                {/* ==================================thdata=============================== */}
                <div style={{ overflowX: "auto" }} className="w-100">
                  <table>
                    <thead>
                      <tr style={{ border: "0" }} className="p-0 m-0">
                        <th className="fs-12px text-black-60 border-0 p-1 text-start">
                          Sr. No.
                        </th>
                        <th className="fs-12px text-black-60 border-0 p-1 text-start">
                          Order No
                        </th>
                        <th className="fs-12px text-black-60 border-0 p-1 text-start">
                          Order Date
                        </th>
                        <th className="fs-12px text-black-60 border-0 p-1 text-start">
                          Dept Count
                        </th>
                        <th className="fs-12px text-black-60 border-0 p-1 text-start">
                          Provisioned
                        </th>
                        <th className="fs-12px text-black-60 border-0 p-1 text-start">
                          Released
                        </th>
                        <th className="fs-12px text-black-60 border-0 p-1 text-start">
                          Action
                        </th>
                      </tr>
                    </thead>
                    {/* ============================tbdata======================= */}
                    <tbody>
                      {budget?.records.map((record, idex) => (
                        <tr style={{ background: "#f9f9f9" }} key={idex}>
                          <td className="fs-14px border-0 p-1 text-start">
                            {idex + 1}
                          </td>
                          <td className="fs-14px border-0 p-1 text-start">
                            {record.budget_order_no}
                          </td>
                          <td className="fs-14px border-0 p-1 text-start">
                            {record.budget_order_date}
                          </td>
                          <td className="fs-14px border-0 p-1 text-start">
                            {record.total_departments}
                          </td>
                          <td className="fs-14px border-0 p-1 text-start">
                            {record.total_scheme_provisional_allocation}
                          </td>
                          <td className="fs-14px border-0 p-1 text-start">
                            {record.total_scheme_released_allocation}
                          </td>
                          <td className="fs-14px border-0 p-1 text-start">
                            <div className=" m-0 fs-14px p-0 d-flex gap-2 align-items-center">
                              <button
                                className={`${
                                  record.l2_status === "1"
                                    ? "bg-success-20"
                                    : record.l2_status === "0"
                                    ? "bg-danger-20"
                                    : "bg-warning-20"
                                } rounded-1 border-0 px-2 py-1 fs-12px d-flex  justify-content-between align-content-center gap-1`}
                                onClick={() => {
                                  Number(record.l2_status) === 0 && navigate(`/view-allocate-budget/${record.id}`);
                                }}
                              >
                                L2{" "}
                                <i
                                  className={`${
                                    record.l2_status === "1"
                                      ? "icon-verified text-success-100"
                                      : record.l2_status === "0"
                                      ? "icon-warning_amber text-danger-100"
                                      : "icon-warning_amber text-warning-100"
                                  } fs-16px`}
                                ></i>
                              </button>
                              <button
                                className={`${
                                  record.l3_status === "1"
                                    ? "bg-success-20"
                                    : record.l3_status === "0"
                                    ? "bg-danger-20"
                                    : "bg-warning-20"
                                } rounded-1 border-0 px-2 py-1 fs-12px d-flex  justify-content-between align-content-center gap-1`}

                                onClick={() => {
                                  Number(record.l3_status) === 0 && navigate(`/view-allocate-budget/${record.id}`);
                                }}
                              >
                                L3{" "}
                                <i
                                  className={`${
                                    record.l3_status === "1"
                                      ? "icon-verified text-success-100"
                                      : record.l3_status === "0"
                                      ? "icon-warning_amber text-danger-100"
                                      : "icon-warning_amber text-warning-100"
                                  } fs-16px`}
                                ></i>
                              </button>
                              <div className="d-flex gap-1 align-items-center">
                                <i
                                  className="icon-remove_red_eye text-info-100"
                                  onClick={() =>
                                    viewAllocationDetails({
                                      ...record,
                                      subhead_budgets: budget.subhead_budgets,
                                    })
                                  }
                                ></i>
                                {(record.l2_status === "2" ||
                                  record.l3_status === "2") && (
                                  <>
                                    <i className="icon-edit text-success-100"></i>
                                    {/* <i className="icon-delete_outline text-danger-100"></i> */}
                                  </>
                                )}
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    {/* ============================total======================= */}
                    <tfoot>
                      <tr className="bg-info-20">
                        <td className="fs-14px border-0 p-1 text-start text-info-100">
                          Total
                        </td>
                        <td className="fs-14px border-0 p-1 text-start"></td>
                        <td className="fs-14px border-0 p-1 text-start"></td>
                        <td className="fs-14px border-0 p-1 text-start"></td>
                        <td className="fs-14px border-0 p-1 text-start">
                          {budget.total_provisional_budget.toLocaleString(
                            "en-IN",
                            { minimumFractionDigits: 2 }
                          )}
                        </td>
                        <td className="fs-14px border-0 p-1 text-start">
                          {budget.total_budget.toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                          })}
                        </td>
                        <td className="fs-14px border-0 p-1 text-start"></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                {/* =============================== tbdata ======================== */}
              </div>

              <div className="px-2 m-0">
                <div className="border mb-2"></div>

                <div className="pb-2 d-flex justify-content-between text-secondary-50 px-4">
                  <button
                    onClick={() =>
                      mainCardSwitch(
                        `subhead_${budget.scheme_id}`,
                        `activity_${budget.scheme_id}`,
                        `subactivity_${budget.scheme_id}`,
                        {
                          scheme_id: budget.scheme_id,
                          subhead: true,
                          activity: false,
                          subActivity: false,
                        }
                      )
                    }
                    className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1 rounded-4 ${
                      activeCard.includes(`subhead_${budget.scheme_id}`)
                        ? "bg-secondary-20"
                        : "bg-white"
                    } `}
                  >
                    {activeCard.includes(`subhead_${budget.scheme_id}`) ? (
                      <i className="icon-remove_circle_outline"></i>
                    ) : (
                      <i className="icon-add_circle_outline"></i>
                    )}
                    Sub head
                  </button>
                  <button
                    onClick={() =>
                      mainCardSwitch(
                        `activity_${budget.scheme_id}`,
                        `subhead_${budget.scheme_id}`,
                        `subactivity_${budget.scheme_id}`,
                        {
                          scheme_id: budget.scheme_id,
                          subhead: false,
                          activity: true,
                          subActivity: false,
                        }
                      )
                    }
                    className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4 ${
                      activeCard.includes(`activity_${budget.scheme_id}`)
                        ? "bg-secondary-20"
                        : "bg-white"
                    } `}
                  >
                    {activeCard.includes(`activity_${budget.scheme_id}`) ? (
                      <i className="icon-remove_circle_outline"></i>
                    ) : (
                      <i className="icon-add_circle_outline"></i>
                    )}
                    Activity
                  </button>
                  <button
                    onClick={() =>
                      mainCardSwitch(
                        `subactivity_${budget.scheme_id}`,
                        `activity_${budget.scheme_id}`,
                        `subhead_${budget.scheme_id}`,
                        {
                          scheme_id: budget.scheme_id,
                          subhead: false,
                          activity: false,
                          subActivity: true,
                        }
                      )
                    }
                    className={` ${
                      activeCard.includes(`subactivity_${budget.scheme_id}`)
                        ? "bg-secondary-20"
                        : "bg-white"
                    } border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}
                  >
                    {activeCard.includes(`subactivity_${budget.scheme_id}`) ? (
                      <i className="icon-remove_circle_outline"></i>
                    ) : (
                      <i className="icon-add_circle_outline"></i>
                    )}
                    Sub-Activity
                  </button>
                </div>
              </div>

              {activeCard.includes(`subhead_${budget.scheme_id}`) && (
                <>
                  <div className="border mx-2"></div>
                  <div style={{ overflowX: "auto" }} className="w-100 px-2">
                    <table className="w-100">
                      <thead>
                        <tr style={{ border: "0" }} className="p-0 m-0">
                          <th className="fs-12px text-black-60 border-0 p-1 text-start">
                            Sub Head
                          </th>
                          <th className="fs-12px text-black-60 border-0 p-1 text-start">
                            Provisional
                          </th>
                          <th className="fs-12px text-black-60 border-0 p-1 text-start">
                            Released
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {budget.subhead_budgets.map((subhead, index) => (
                          <tr key={index}>
                            <td className="fs-14px border-0 p-1 text-start">
                              {subhead.name}
                            </td>
                            <td className="fs-14px border-0 p-1 text-start">
                              {subhead.provisional_budget}
                            </td>
                            <td className="fs-14px border-0 p-1 text-start">
                              {subhead.budget}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
              {activeCard.includes(`activity_${budget.scheme_id}`) && (
                <>
                  <div className="border mx-2"></div>
                  <div className=" pb-2 d-flex flex-column gap-1 mt-2 mx-0 px-2">
                    {budget.subhead_budgets.map((subhead, index) => (
                      <Accordion style={{ border: "0" }} key={index}>
                        <Accordion.Item
                          eventKey={`subhead_activity_${subhead.subhead_id}`}
                          style={{ borderRadius: "0", border: "0" }}
                        >
                          <Accordion.Header
                            onClick={() =>
                              toggleAccordion(
                                `subhead_activity_${subhead.subhead_id}`
                              )
                            }
                          >
                            <div className="w-100 d-flex justify-content-between">
                              <span>{subhead.name}</span>
                              <span
                                className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                style={{
                                  height: "13.33px",
                                  width: "13.33px",
                                }}
                              >
                                {activeKeys.includes(
                                  `subhead_activity_${subhead.subhead_id}`
                                )
                                  ? "-"
                                  : "+"}
                              </span>
                            </div>
                          </Accordion.Header>

                          <Accordion.Body>
                            <div
                              style={{ overflowX: "auto" }}
                              className="w-100 px-2"
                            >
                              <table className="w-100">
                                <thead>
                                  <tr
                                    style={{ border: "0" }}
                                    className="p-0 m-0"
                                  >
                                    <th className="fs-12px text-black-60 border-0 p-1 text-start">
                                      Activity
                                    </th>
                                    <th className="fs-12px text-black-60 border-0 p-1 text-start">
                                      Provisional
                                    </th>
                                    <th className="fs-12px text-black-60 border-0 p-1 text-start">
                                      Released
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {subhead.activities.map(
                                    (activity, actIndex) => (
                                      <tr key={actIndex}>
                                        <td className="fs-14px border-0 p-1 text-start">
                                          {activity.activity}
                                        </td>
                                        <td className="fs-14px border-0 p-1 text-start">
                                          {activity.provisional_budget}
                                        </td>
                                        <td className="fs-14px border-0 p-1 text-start">
                                          {activity.budget}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    ))}
                  </div>
                </>
              )}
              {activeCard.includes(`subactivity_${budget.scheme_id}`) && (
                <>
                  <div className="border mx-2"></div>
                  <div className=" pb-2 d-flex flex-column gap-1 mt-2 mx-0 px-2">
                    {budget.subhead_budgets.map((subhead, index) =>
                      subhead.activities.map((activity, actIndex) => (
                        <Accordion key={actIndex} style={{ border: "0" }}>
                          <Accordion.Item
                            eventKey={`subhead_subactivity_${activity.subhead_activity_id}`}
                            style={{ borderRadius: "0", border: "0" }}
                          >
                            <Accordion.Header
                              onClick={() =>
                                toggleAccordion(
                                  `subhead_subactivity_${activity.subhead_activity_id}`
                                )
                              }
                            >
                              <div className="w-100 d-flex justify-content-between">
                                <span>
                                  {subhead.name} | {activity.activity}
                                </span>
                                <span
                                  className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                  style={{
                                    height: "13.33px",
                                    width: "13.33px",
                                  }}
                                >
                                  {activeKeys.includes(
                                    `subhead_subactivity_${activity.subhead_activity_id}`
                                  )
                                    ? "-"
                                    : "+"}
                                </span>
                              </div>
                            </Accordion.Header>

                            <Accordion.Body>
                              <div
                                style={{ overflowX: "auto" }}
                                className="w-100 px-2"
                              >
                                <table className="w-100">
                                  <thead>
                                    <tr
                                      style={{ border: "0" }}
                                      className="p-0 m-0"
                                    >
                                      <th
                                        className="fs-12px text-black-60 border-0 p-1 text-start"
                                        style={{ width: "60%" }}
                                      >
                                        Sub-Activity
                                      </th>
                                      <th
                                        className="fs-12px text-black-60 border-0 p-1 text-start"
                                        style={{ width: "20%" }}
                                      >
                                        Provisional
                                      </th>
                                      <th
                                        className="fs-12px text-black-60 border-0 p-1 text-start"
                                        style={{ width: "20%" }}
                                      >
                                        Released
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {activity.subactivities.map(
                                      (subactivity, subIndex) => (
                                        <tr key={subIndex}>
                                          <td className="fs-14px border-0 p-1 text-start">
                                            {subactivity.subactivity}
                                          </td>
                                          <td className="fs-14px border-0 p-1 text-start">
                                            {subactivity.provisional_budget}
                                          </td>
                                          <td className="fs-14px border-0 p-1 text-start">
                                            {subactivity.budget}
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      ))
                    )}
                  </div>
                </>
              )}
            </div>
          ))}
        </div>

        {/* ================== right side bar ================== */}

        <div className=" col-12 col-lg-3 px-3 pb-2 m-0">
          <div className="totals">
            <div
              className="bg-success-20 p-3 d-flex flex-column"
              style={{
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
              }}
            >
              <span className="text-success-100 fs-12px">
                Total Provisional Budget FY{" "}
                {fy_list?.map((val, ind) => {
                  return val?.id == globalDateId && val?.year;
                })}
              </span>
              <span className="text-success-100 fs-20px ">
                {data
                  .reduce((sum, s) => sum + s.total_provisional_budget, 0)
                  .toLocaleString("en-IN", { minimumFractionDigits: 2 })}
              </span>
            </div>

            <div
              className="bg-info-20 p-3 d-flex flex-column "
              style={{
                borderTop: "1px solid #0DCAF0",
                // borderBottom: "1px solid #0DCAF0",
              }}
            >
              <span className="text-black-60 fs-12px">
                Total Released Budget FY{" "}
                {fy_list?.map((val, ind) => {
                  return val?.id == globalDateId && val?.year;
                })}
              </span>
              <span className="fs-20px  text-success-100 ">
                {data
                  .reduce((sum, s) => sum + s.total_budget, 0)
                  .toLocaleString("en-IN", { minimumFractionDigits: 2 })}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* ==============================overlay====================== */}

      <div className={`overlay ${overlay ? "d-none" : null}  `}></div>
      <BudgetAllocationOverlay
        overlay={overlay}
        setOverlay={setOverlay}
        overlayDropDown={overlayDropDown}
        setOverlayDropDown={setOverlayDropDown}
        toggleAccordion={toggleAccordion}
        bodyRef={bodyRef}
        activeKeys={activeKeys}
        activeCard={activeCard}
        setActiveCard={setActiveCard}
        allocationDetails={allocationDetails}
        fy_list={fy_list}
      />
    </div>
  );
};
export default BudgetAllocationListNew;
